export const mockSecondaryCategories = [
  {
    title: 'Art',
    count: '20k',
    subcategories: [
      { name: 'Coins & Badges', url: '/art/coins-badges' },
      { name: 'Mathematical Art', url: '/art/mathematical-art' },
      { name: 'Scans & Replicas', url: '/art/scans-replicas' },
      { name: 'Signs & Logos', url: '/art/signs-logos' },
      { name: 'Sculptures', url: '/art/sculptures' },
    ],
  },
  {
    title: 'Fashion',
    count: '20k',
    subcategories: [
      { name: 'Bags & Purses', url: '/fashion/bags-purses' },
      { name: 'Belts', url: '/fashion/belts' },
      { name: 'Glasses', url: '/fashion/glasses' },
      { name: 'Shoes', url: '/fashion/shoes' },
      { name: 'Wallets', url: '/fashion/wallets' },
    ],
  },
  {
    title: 'Gadgets',
    count: '20k',
    subcategories: [
      { name: 'Audio', url: '/gadgets/audio' },
      { name: 'Keychains', url: '/gadgets/keychains' },
      { name: 'Office', url: '/gadgets/office' },
      { name: 'PC & Laptop', url: '/gadgets/pc-laptop' },
      { name: 'Phone cases', url: '/gadgets/phone-cases' },
      { name: 'Tablets', url: '/gadgets/tablets' },
      { name: 'Video', url: '/gadgets/video' },
    ],
  },
  {
    title: 'Games & Toys',
    count: '20k',
    subcategories: [
      { name: 'Board Games', url: '/games-toys/board-games' },
      { name: 'Dice', url: '/games-toys/dice' },
      { name: 'Game Accessories', url: '/games-toys/game-accessories' },
      { name: 'Puzzle', url: '/games-toys/puzzle' },
      { name: 'Toys', url: '/games-toys/toys' },
    ],
  },
  {
    title: 'Hobby & DIY',
    count: '20k',
    subcategories: [
      { name: 'Automotive', url: '/hobby-diy/automotive' },
      { name: 'Electronics', url: '/hobby-diy/electronics' },
      { name: 'Hand Tools', url: '/hobby-diy/hand-tools' },
      { name: 'Mechanical Parts', url: '/hobby-diy/mechanical-parts' },
    ],
  },
  {
    title: 'Home & Office',
    count: '20k',
    subcategories: [
      { name: 'Bathroom', url: '/home-office/bathroom' },
      { name: 'Decorations', url: '/home-office/decorations' },
      { name: 'Furniture', url: '/home-office/furniture' },
      { name: 'Kitchen', url: '/home-office/kitchen' },
    ],
  },
  {
    title: 'Jewelry',
    count: '20k',
    subcategories: [
      { name: 'Coins & Badges', url: '/jewelry/coins-badges' },
      { name: 'Mathematical Art', url: '/jewelry/mathematical-art' },
      { name: 'Scans & Replicas', url: '/jewelry/scans-replicas' },
      { name: 'Signs & Logos', url: '/jewelry/signs-logos' },
    ],
  },
]
